var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "supplierContacts" },
    [
      _c("el-popover", { attrs: { placement: "bottom", trigger: "hover" } }, [
        _c("div", { staticClass: "related-content" }, [
          _c("p", [_vm._v("工艺描述")]),
          _vm._v(" "),
          _c("p", [_c("span", [_vm._v(_vm._s(_vm.rowData.remark))])]),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              color: "#FF8850",
              "text-decoration": "underline",
              cursor: "pointer",
            },
            attrs: { slot: "reference" },
            slot: "reference",
          },
          [_c("br"), _vm._v("工艺描述")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }